<template>
  <!--    赛事报名列表-->
  <div class="gray-back">
    <div class="mine-box-title">我报名的赛事</div>
    <div class="mine-content">
<!--      <div class="box-operate">-->
<!--        <el-button type="primary" icon="el-icon-plus" @click="addShow = true">新增运动员</el-button>-->
<!--      </div>-->
      <el-tabs v-model="active" @tab-click="onStatusChange">
        <el-tab-pane label="报名中" name="1"></el-tab-pane>
        <el-tab-pane label="报名成功" name="2"></el-tab-pane>
        <el-tab-pane label="全部" name="0"></el-tab-pane>
      </el-tabs>
      <el-table :data="list" ref="table" :show-header="false">
        <!--        <el-table-column type="index" label="序号" width="56" align="center"></el-table-column>-->
        <el-table-column prop="name" label="用户名" min-width="160">
          <template slot-scope="scope">
            <div class="">{{scope.row.saiqu_name}}</div>
            <div class="gray-light">
              {{scope.row.mingcheng}}
            </div>
            <div class="goods-num gray-light">人数 {{scope.row.membercount}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="价格">
          <template slot-scope="scope">
            <div class="table-goods-price" ><span>¥</span>{{scope.row.total_price}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="时间" min-width="100">
          <template slot-scope="scope">
            <div>{{scope.row.create_time_str}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="用户名" min-width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.memberstatus==1">
              秩序册
            </el-tag>
            <el-tag v-else-if="scope.row.memberstatus==2">
              项目填写
            </el-tag>
            <el-tag v-else-if="scope.row.memberstatus==3">
              人员统计
            </el-tag>
            <el-tag v-else-if="scope.row.memberstatus==4">
              住宿统计
            </el-tag>
            <el-tag v-else-if="scope.row.memberstatus==5" type="danger">
              等待付款
            </el-tag>
            <el-tag v-else-if="scope.row.memberstatus==6" type="success">
              报名成功
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="right" min-width="160px">
          <template slot-scope="scope">
            <el-button
                size="medium"
                type="primary"
                @click="goDetail(scope.row)">查看详情
            </el-button>
            <el-button
                size="medium"
                v-rblink="{name:'ISaiApplyVideoList',query:{id:scope.row.id}}" 
                v-if="scope.row.show_upload_video"
                >上传视频
            </el-button>
            <el-button
                size="medium"
                v-if="scope.row.have_cert">下载证书
            </el-button>
            <el-button
                size="medium"
                v-if="scope.row.have_bu"
                @click="orderBu(scope.row)">补缴费用
            </el-button>
            <el-button
                size="medium"
                v-if="scope.row.memberstatus!=6"
                @click="beizhu(scope.row)">备注信息
            </el-button>
            <el-button
                size="medium"
                v-if="scope.row.memberstatus==6"
                @click="successInfo(scope.row)">详情
            </el-button>
            <el-button
                size="medium"
                v-if="scope.row.memberstatus!=6"
                @click="onDelete(scope.row)">删除
            </el-button>
            <el-button
                size="medium"
                v-if="scope.row.memberstatus==6"
                @click="kaipiao(scope.row)">申请开票
            </el-button>
            <el-button
                size="medium"
                v-if="scope.row.memberstatus==6&&scope.row.can_youxiu==1"
                @click="goCpJlApply(scope.row)">申报优秀教练员
            </el-button>
          </template>
        </el-table-column>

<!--        <p slot="append" style="text-align:center; line-height:50px;"-->
<!--           v-if="params.pageNo < row.totalpage && list.length > 0" @click="onLoad">-->
<!--          <el-link>点击加载更多</el-link>-->
<!--        </p>-->
      </el-table>
      <div class="table-pagination">
        <el-pagination
            background
            @current-change="handleCurrentChange" :current-page="parseInt(row.currentpage)"
            :page-size="params.pageSize" layout="total, prev, pager, next"
            :total="row.total">
        </el-pagination>

      </div>
    </div>

  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 50px;*/
  background: rgba(248, 248, 248, 1);
  min-height: 90vh;
}

.van-pull-refresh {
  margin-top: 0.3rem
}

.title-left span {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}

.normal-btn {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 26px;
  width: 75px;
  height: 26px;
  border-radius: 13px;
  border: 1px solid rgba(0, 0, 0, 1);
  margin-right: 0.5rem;
}

.count_edit {
  width: 87px;
  height: 26px;
  background: linear-gradient(90deg, rgba(254, 200, 53, 1) 0%, rgba(255, 173, 25, 1) 100%);
  border-radius: 13px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 26px;
  margin-right: 0.5rem
}

.row-list {
  border-bottom: 0.1rem solid #EFEFEF;
  background: #fff;
  margin: 0.2rem;
  border-radius: 0.2rem;
}

.row-title-img {
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.1rem;
}

.row-title {
  padding: 0.1rem 0.33rem;
}

.title-right {
  color: #FD2840;
}


.row-left {
  width: 80%;
}

.row-right {
  text-align: center;
}

.goods-detail {
  width: 72%;
}

.row-left-img {
  width: 1.44rem;
  height: 1.44rem;
  border-radius: 5px;
  margin-right: 0.2rem;
}

.row-goods {
  padding: 0.2rem 0.3rem;
  border-bottom: 1px solid #EFEFEF;
}

.goods-name {
  font-size: 12px;
  margin-bottom: 0.6rem;
}

.table-goods-price {
  font-weight: 500;
  color: rgba(253, 40, 64, 1);
}

.goods-price span {
  font-size: 12px;
}

.goods-num {
  font-size: 12px;
}

.pay_order {
  width: 87px;
  height: 26px;
  background: linear-gradient(90deg, rgba(254, 200, 53, 1) 0%, rgba(255, 173, 25, 1) 100%);
  border-radius: 13px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 26px;
  margin-right: 0.5rem
}

.row-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.2rem 0.33rem;
  font-size: 12px;
  text-align: center;
  line-height: 0.52rem;
}

.look-order {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 26px;
  width: 75px;
  height: 26px;
  border-radius: 13px;
  border: 1px solid rgba(0, 0, 0, 1);
  margin-right: 0.5rem;
}

.invite-btn {
  width: 2.1rem;
  height: 0.52rem;
  background: rgba(255, 0, 0, 1);
  border: 1px solid rgba(255, 0, 0, 1);
  border-radius: 4px;
  color: #fff;
}

</style>

<script>
import Vue from 'vue';

import {
  Cell, CellGroup, Toast, Dialog, Icon, PullRefresh, List, Tag, Button, DropdownMenu, DropdownItem,
  Tab,
  Tabs,
  NoticeBar,
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(DropdownMenu).use(Tab).use(Tabs).use(DropdownItem);
export default {
  name: 'SaiApplyList',
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
  },
  data: function () {
    return {
      loginShow: false,
      active: '1',
      isLoading: false,
      loading: false,
      finished: false,
      params: {
        pageNo: 1,
        pageSize: 10,
        status: 1
      },
      homeTop: 0,
      list: [],
      userType: 2,
      row: {}
    }
  },
  mounted() {
    document.title = "报名记录"
    let that = this;
    // console.log(this.$route.meta)
    if (!this.$route.meta.isBack) {
      // 清空查询条件和数据
      that.list = [];
      that.active = '1';
      that.params.pageNo = 1;
      that.params.status = 1;
      that.loading = true;
      that.finished = false;
      that.getList()

      if (this.$route.query.status) {
        that.params.status = this.$route.query.status;
      }
    }
    document.getElementById('app').scrollTop = this.homeTop || 0
    this.$route.meta.isBack = false;

  },
  destroyed() {
  },
  methods: {
    getList() {
      let that = this;
      that.$api.get('/api/sai/applylist', that.params, (res) => {
        that.loading = false;

        if (res.data.currentpage == 1) {
          that.isLoading = false;
          that.list = res.data.list
        } else {
          let list = that.list.concat(res.data.list);

          that.list = list;
        }

        if (res.data.list.length == 0) {
          that.finished = true;
        }
        that.params.pageNo += 1;
        that.row = res.data
      })
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.params.pageNo = val
      this.list = []
      this.getList()
    },

    // 上拉加载
    // （页面显示没有更多了的原因 ）数据加载过慢 导致第一页数据未获取到时，已经请求第二页数据了
    // 可以延迟异步的时间
    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log('this.params.pageNo')

      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.getList()
        }, 500);
      }

    },

    // 跳转订单详情
    goDetail(order) {
      // 判断是否成团
      console.log(order)
      rbLink({
        'name': 'ISaiApplyDetail',
        'query': {
          id: order.id
        }
      })

    },

    action(item, index) {
      this.$router.push({
        name: "QcxjStationApply",
        query: {
          id: item.id
        }
      })

    },

    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.getList();
    },


    // 更改状态
    onStatusChange(tab) {
      let index = tab.name

      console.log('onStatusChange', index)
      let that = this;
      that.params.status = index;
      that.params.pageNo = 1;

      // 激活下拉
      that.finished = false;
      that.loading = true;
      that.list = [];
      that.getList()
    },

    kaipiao(order){
      if(order.can_kaipiao!=1){
        this.$message.info('亲在赛后才能开票，而且是电子票哦～');
        return ;
      }

      rbLink({
        'name' : 'SaiApplyFapiao',
        'query':{
          id: order.id
        }
      } )
    },

    beizhu(order){
      rbLink({
        'name' : 'SaiApplyBeizhu',
        'query':{
          id: order.id
        }
      } )
    },
    orderBu(order){
      rbLink({
        'name' : 'ISaiApplyFormStepBu',
        'query':{
          id: order.bu_id
        }
      } )
    },
    successInfo(order){
      rbLink({
        'name' : 'ISaiApplyFormSuccess',
        'query':{
          id: order.id
        }
      } )
    },
    goCpJlApply(  order) {
      // 判断是否成团
      console.log( order)
      rbLink({
        'name' : 'ISaiApplyFormJiaolianCaipan',
        'query':{
          id: order.id
        }
      } )

    },

    onDelete(order){
      let that = this;
      that.$confirm('您确定删除报名记录吗?删除后无法恢复','确认', {
        showClose: false,
        showCancelButton: true,
        closeOnPressEscape: false,
        closeOnClickModal: false,
      }).then(() => {
        that.$api.post('/api/isai/applydelete', {
          id:order.id
        }, r => {
          that.onRefresh();
        },r=>{
          that.$message.warning(r.msg);
        });
      }).catch(() => {
      });
    }


  }
}
</script>



// WEBPACK FOOTER //
// SaiApplyList.vue?cfee42f0